module.exports = __webpack_public_path__ + "static/media/5-3.e898f240.mp3";